export default __webpack_public_path__ + "static/media/best-reports-main.0d9ddae2.png";